/**
 * [AYNI] Bottom-Sheet Popup
 * Öffnet/schließt die Overlays von snippets/ayni-size-guide.liquid und
 * snippets/ayni-free-exchange.liquid.
 *
 * WICHTIG — Event-Delegation statt direkter Listener:
 * Der Farb-Variant-Wechsel (sht-variation, siehe theme.js) ersetzt bei
 * einem Klick auf ein Farb-Swatch den kompletten Inhalt der Produkt-Info-
 * Sektion per `innerHTML =`. Dabei werden alle bis dahin per
 * addEventListener() gebundenen Handler verworfen UND neu eingefügte
 * <script>-Tags werden vom Browser NICHT erneut ausgeführt.
 *
 * Fix: Alle Listener hängen nur EINMALIG an `document` und arbeiten über
 * e.target.closest(...). Das überlebt jeden DOM-Austausch.
 *
 * Swipe-to-close vs. Scrollen:
 * Eine Geste wird beim ersten nennenswerten Move einmalig als 'drag' oder
 * 'scroll' festgelegt und behält diese Rolle bis touchend. Gezogen wird nur,
 * wenn die Geste außerhalb des scrollbaren Bodys beginnt oder der Body ganz
 * oben steht — sonst gehört die Geste dem Scrollen.
 */
(function () {
  'use strict';

  if (window.__asgBound) return;
  window.__asgBound = true;

  var DRAG_THRESHOLD = 6;    // px, bevor die Geste eine Rolle bekommt
  var CLOSE_DISTANCE = 120;  // px, ab denen losgelassen wird = schließen

  function getSheet(overlay) {
    return overlay.querySelector('.asg-overlay__sheet');
  }

  function openOverlay(overlay) {
    overlay.setAttribute('aria-hidden', 'false');
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeOverlay(overlay) {
    var sheet = getSheet(overlay);
    overlay.setAttribute('aria-hidden', 'true');
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    if (sheet) {
      sheet.removeAttribute('data-dragging');
      sheet.style.transform = '';
    }
  }

  // ─── Open / Close Trigger (delegiert) ───
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-asg-trigger]');
    if (trigger) {
      e.preventDefault();
      var overlayId = trigger.getAttribute('aria-controls');
      var overlay = overlayId && document.getElementById(overlayId);
      if (overlay) openOverlay(overlay);
      return;
    }

    var closer = e.target.closest('[data-asg-close]');
    if (closer) {
      var closeOverlayEl = closer.closest('.asg-overlay');
      if (closeOverlayEl) closeOverlay(closeOverlayEl);
    }
  });

  // ─── Escape zum Schließen (delegiert) ───
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var openOverlayEl = document.querySelector('.asg-overlay.is-open');
    if (openOverlayEl) closeOverlay(openOverlayEl);
  });

  // ─── Swipe-to-close (delegiert, Zustand als Expando am Sheet-Knoten) ───
  document.addEventListener('touchstart', function (e) {
    var sheet = e.target.closest('.asg-overlay__sheet');
    if (!sheet) return;

    var body = e.target.closest('.asg-overlay__body');

    sheet.__asgStartY = e.touches[0].clientY;
    sheet.__asgDrag = 0;
    sheet.__asgRole = null; // null = noch unentschieden, dann 'drag' | 'scroll'

    // Ziehen ist nur erlaubt, wenn die Geste nicht im scrollbaren Inhalt
    // beginnt, oder der Inhalt bereits am oberen Anschlag steht.
    sheet.__asgCanDrag = !body || body.scrollTop <= 0;
  }, { passive: true });

  document.addEventListener('touchmove', function (e) {
    var sheet = e.target.closest('.asg-overlay__sheet');
    if (!sheet || sheet.__asgStartY == null) return;

    var delta = e.touches[0].clientY - sheet.__asgStartY;

    // Rolle der Geste einmalig festlegen und bis touchend beibehalten.
    if (sheet.__asgRole === null) {
      if (Math.abs(delta) < DRAG_THRESHOLD) return;
      sheet.__asgRole = (delta > 0 && sheet.__asgCanDrag) ? 'drag' : 'scroll';
      if (sheet.__asgRole === 'drag') sheet.setAttribute('data-dragging', '');
    }

    if (sheet.__asgRole !== 'drag') return;

    // Nach oben über den Ausgangspunkt hinaus wird nicht gezogen.
    if (delta < 0) delta = 0;

    e.preventDefault(); // verhindert paralleles Rubber-Banding auf iOS
    sheet.__asgDrag = delta;
    sheet.style.transform = 'translateY(' + delta + 'px)';
  }, { passive: false });

  document.addEventListener('touchend', function (e) {
    var sheet = e.target.closest('.asg-overlay__sheet');
    if (!sheet || sheet.__asgStartY == null) return;

    var wasDragging = sheet.__asgRole === 'drag';
    var travelled = sheet.__asgDrag;

    sheet.removeAttribute('data-dragging');
    sheet.__asgStartY = null;
    sheet.__asgRole = null;
    sheet.__asgDrag = 0;

    if (!wasDragging) return;

    if (travelled > CLOSE_DISTANCE) {
      var overlay = sheet.closest('.asg-overlay');
      if (overlay) closeOverlay(overlay);
    } else {
      sheet.style.transform = '';
    }
  });

  // ─── Focus trap (delegiert; nur ein Overlay ist je Instanz offen) ───
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;
    var overlay = document.querySelector('.asg-overlay.is-open');
    if (!overlay) return;
    var focusable = overlay.querySelectorAll('button,[href],input,select,textarea,[tabindex]:not([tabindex="-1"])');
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (e.shiftKey ? document.activeElement === first : document.activeElement === last) {
      e.preventDefault();
      (e.shiftKey ? last : first).focus();
    }
  });
})();